/**
 * v-permission 自定义指令
 * 
 * 来源: 文件45(PERMISSION-MATRIX) — 26个permissionId × 8角色矩阵
 * 
 * 用法:
 *   v-permission="'BOOKING_VIEW'"           // 单个权限
 *   v-permission="['BOOKING_VIEW', 'BOOKING_CREATE']"  // 任一权限
 * 
 * 无权限时元素从DOM中移除（不是隐藏，是移除）
 */

import type { Directive, DirectiveBinding } from 'vue'
import { useAuthStore } from '@/stores/auth'

function checkPermission(value: string | string[]): boolean {
  const authStore = useAuthStore()
  if (typeof value === 'string') {
    return authStore.hasPermission(value)
  }
  return authStore.hasAnyPermission(...value)
}

function handle(el: HTMLElement, binding: DirectiveBinding) {
  const { value } = binding
  if (!value) return

  const hasPermission = checkPermission(value)
  if (!hasPermission) {
    el.parentNode?.removeChild(el)
  }
}

export const permissionDirective: Directive = {
  mounted: handle,
  updated: handle,
}
